<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="row justify-content-center">
                            <div class="col-lg-3 order-lg-2">
                                <div class="card-profile-image">
                                    <a href="#">
                                        <img v-lazy="'img/moi-blank-hi.png'" class="rounded-circle">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                                <div class="card-profile-actions py-4 mt-lg-0">
                                    <a type="default" size="sm" class="float-right" href="mailto:christophe.moine@free.fr">{{ $t('email') }}</a>
                                </div>
                            </div>
                            <div class="col-lg-4 order-lg-1">
                                <div class="card-profile-stats d-flex justify-content-center">
                                    <div>
                                        <a class="heading" href="https://github.com/cmoine?tab=repositories">{{repoCount}}</a>
                                        <span class="description">GitHub repos</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center mt-5">
                            <h3>Christophe Moine
                                <span class="font-weight-light">, {{ yxp() }} XP</span>
                            </h3>
                            <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Lille, France</div>
                            <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>Full Stack Developer - <a href="https://www.qimaone.com/">QIMAone</a></div>
                            <div><i class="ni education_hat mr-2"></i><a href="https://www.insa-toulouse.fr/">Institut National des Sciences Appliqu&eacute;es</a></div>
                        </div>
                        <div class="mt-5 py-5 border-top text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-9">
                                    <p v-html="summary"></p>
                                    <a href="#" @click.stop.prevent="doScroll">Show more</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
        <section-cloud ref="sectionCloudChild"/>

        <section-devops/>

        <section-tech-stack/>

        <section-achievements/>

        <section-footer/>
    </div>
</template>
<script>
import moment from 'moment'
import SectionCloud from './SectionCloud.vue';
import SectionDevops from './SectionDevops.vue';
import SectionFooter from './SectionFooter.vue';
import SectionTechStack from './SectionTechStack.vue';
import SectionAchievements from './SectionAchievements.vue';

export default {
    components: {
        SectionCloud,
        SectionDevops,
        SectionFooter,
        SectionTechStack,
        SectionAchievements
    },
    data() {
        return {
            repoCount: ""
        }
    },
    mounted () {
        this.axios.get('https://cmoine.netlify.app/.netlify/functions/github-wrapper')
            .then((response) => {
                this.repoCount=response.data.length
            })
    },
    methods: {
        age(dob) {
            return this.getYears(this.getDuration(dob))
        },
        getDuration(d) {
            return moment.duration(moment(new Date()).diff(moment(d)))
        },
        getYears(d) {
            return Math.floor(d.asYears())
        },
        getMonths(d) {
            return Math.floor(d.asMonths() - this.getYears(d) * 12)
        },
        yxp() {
            var d=this.getDuration([2004, 9, 1])
            var y=this.getYears(d)
            var m=this.getMonths(d)
            var result=y + ' ' + this.$t('years') + ' ' + this.$tc('months', m, {count: m})
            return result;
        },
        doScroll() {
            this.$refs.sectionCloudChild.$refs.showMore.scrollIntoView({behavior: "smooth"})
        }
    },
    computed: {
        summary() {
            return this.$t('summary', {age : this.age([1980,8,2]), son: this.age([2014,1,17]), twins: this.age([2018,2,5])})
        }
    }
};
</script>
<style>
</style>
<i18n>
{
  "en": {
      "yo": "y.o.",
      "years": "years",
      "months": "|1 month|{count} months",
      "summary": "A very entousiastic swiss-knife developer ({age} y.o.). Always juggling between my passions and my parenthood: {son} y.o. son, and {twins} y.o. twins 👶😅. My curiosity always pushed me to learn new programming languages, paradigms, areas, ... My quest to improve systems is endless, and generally lead me to great creativity!",
      "email": "drop me a line"
  },
  "fr": {
      "yo": "ans",
      "years": "ann&eacute;es",
      "months": "|{count} mois",
      "summary": "D&eacute;veloppeur et grand entousiasme du d&eacute;veloppement ({age} ans). Toujours &agrave; jongler entre mes passions et ma parentalit&eacute;: un fils de {son} ans, et des jumeaux de {twins} ans 👶😅. Ma curiosit&eacute; m'a toujours pouss&eacute; vers l'apprentissage de nouveaux langages, paradigmes, domains, ... Ma qu&ecirc;te pour am&eacute;liorer les syst&egrave;mes est sans fin, et me m&ecirc;nent g&eacute;n&eacute;ralement &agrave; une grande cr&eacute;ativit&eacute;!",
      "email": "Laissez moi un mot"
  }
}
</i18n>
